"use strict";
// Copyright 2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
var BitrateParameters = /** @class */ (function () {
    function BitrateParameters() {
    }
    return BitrateParameters;
}());
exports.default = BitrateParameters;
//# sourceMappingURL=BitrateParameters.js.map